export enum GroupModulesEnum {
  USERS = "USERS", // Usuários
  COMPANIES = "COMPANIES", // Empresas
  CLIENTS = "CLIENTS", // Carteira de cliente
  PROPOSES = "PROPOSES", // Minhas Propostas
  ACADEMY = "ACADEMY", // Academia
  SHOWCASE = "SHOWCASE", // Vitrine
  MARKETING = "MARKETING", // Marketing
  OPEN_FINANCE = "OPEN_FINANCE", // Open finance
  INVESTMENT = "INVESTMENT", // Investimento
  REAL_ESTATE_CREDIT = "REAL_ESTATE_CREDIT", //  Crédito imobiliário
  COMMISSION = "COMMISSION", // Minha comissão
  MAIS_DIGITAL_PLAY = "MAIS_DIGITAL_PLAY", //Mais Digital Play
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS", // Termos e condições
  WHITE_LABEL = "WHITE_LABEL", // White Label
  SERASA = "SERASA", // Serasa
  STORE = "STORE", //Loja
  LEADS = 'LEADS',
  SIMULATIONS = 'SIMULATIONS'
}
